import React, { useEffect, useState, useContext } from "react";
import CelebrationScreen from "../Celebration/CelebrationScreen";
import StakeholderListCard from "../widgets/Stakeholders/StakeholderListCard.jsx";
import { progressService } from "../../../../services/progressService.js";
import { UserContext } from "../../../../../src/UserContext.js";

const StakeholderListCelebration = ({ userId, subsectionId, onNextStep }) => {
  const [selectedCard, setSelectedCard] = useState(null);
  const { user } = useContext(UserContext);

  const userName = user?.firstName ? `${user.firstName}` : "";

  useEffect(() => {
    async function loadSelection() {
      try {
        const progress = await progressService.getUserProgress(
          userId,
          subsectionId
        );

        const savedCard = progress?.data?.stakeholders;

        if (savedCard) {
          setSelectedCard(savedCard);   // 👍 full object used directly
        }
      } catch (err) {
        console.error("Error loading saved root cause:", err);
      }
    }

    loadSelection();
  }, [userId, subsectionId]);

  if (!selectedCard) return <div className="p-10">Loading...</div>;

  return (
    <CelebrationScreen
      title={`Amazing ${userName}! You’ve done something only 1% of the hired workplace does –`}
      subtitle=""
      theme="meeting_personality"
      onNext={onNextStep}
      hideBack={true}
      fullScreen={true}
    >
      <StakeholderListCard
        mode="data"
        data={selectedCard}   // 👈 full card object
        userId={userId}
        selectable={false}
        compact={false}
      />
    </CelebrationScreen>
  );
};

export default StakeholderListCelebration;
